module.exports = __webpack_public_path__ + "static/media/blogoverzicht_boom_detail_rechts.f0639d84.svg";